import { render, staticRenderFns } from "./BenefitsTbBy.vue?vue&type=template&id=7fa764ee"
import script from "./BenefitsTbBy.vue?vue&type=script&lang=js"
export * from "./BenefitsTbBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports